import React from 'react';
import LoginMosaic from './LoginMosaic';

// Moldura visual comum das telas de autenticação: mosaico de fundo + card
// centralizado, com efeito de vidro fosco sobre o fundo.
function AuthShell({ title, children }) {
  return (
    <div className="relative flex min-h-screen items-center justify-center px-4 py-12">
      <LoginMosaic />
      <div className="w-full max-w-md">
        <div className="mb-6 text-center">
          <h1 className="text-2xl font-bold tracking-tight text-white drop-shadow">Mundo Teen</h1>
          <p className="text-sm text-slate-200/80">Portal de pesquisa para educadores</p>
        </div>
        <div className="rounded-none border border-white/10 bg-slate-950/90 p-8 shadow-2xl backdrop-blur">
          {title && <h2 className="mb-5 text-center text-lg font-semibold text-slate-100">{title}</h2>}
          {children}
        </div>
      </div>
    </div>
  );
}

export default AuthShell;
